<template>
  <DialogTemplate>
    <div
      class="py-2 px-2 mb-4"
      style="max-width: 520px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('tips.practice.range_builder.title') }}
      </div>
      <div
        v-for="item in options"
        :key="item.title"
      >
        <div class="f-align-center pb-1 weight_700 mt-6">
          {{ item.title }}
        </div>
        <div v-html="item.text"></div>
        <div
          class="d-flex flex-wrap mt-1"
          style="max-width: 400px"
        >
          <div
            v-for="a in item.actions"
            :key="a.clr + item.title"
            :style="`background:var(${a.clr})`"
            class="rb-dialog_action mt-2 mr-2 pa-2 px-3 text-normal weight_500"
          >
            {{ a.name }}
          </div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'RangeBuilderHelpDialog',
  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    options() {
      return [
        {
          title: this.$t('tips.practice.range_builder.easy'),
          text: this.$t('tips.practice.range_builder.easy_explanation'),
          actions: [
            { name: this.$t('browse.bet_all'), clr: '--clr-R_default-initial' },
            { name: 'Check', clr: '--clr-X' },
          ],
        },
        {
          title: this.$t('tips.practice.range_builder.medium'),
          text: this.$t('tips.practice.range_builder.medium_explanation'),
          actions: [
            { name: this.$t('browse.bet_overbet'), clr: '--clr-R4-initial' },
            { name: this.$t('browse.bet_large'), clr: '--clr-R3-initial' },
            { name: this.$t('browse.bet_medium'), clr: '--clr-R2-initial' },
            { name: this.$t('browse.bet_small'), clr: '--clr-R1-initial' },
            { name: 'Check', clr: '--clr-X' },
          ],
        },
        {
          title: this.$t('tips.practice.range_builder.hard'),
          text: this.$t('tips.practice.range_builder.hard_explanation'),
          actions: [
            { name: `${this.$t('browse.bet_all')} 150%`, clr: '--clr-R4-initial' },
            { name: `${this.$t('browse.bet_all')} 100%`, clr: '--clr-R3-initial' },
            { name: `${this.$t('browse.bet_all')} 75%`, clr: '--clr-R2_2-initial' },
            { name: `${this.$t('browse.bet_all')} 50%`, clr: '--clr-R1_2-initial' },
            { name: `${this.$t('browse.bet_all')} 33%`, clr: '--clr-R1-initial' },
            { name: 'Check', clr: '--clr-X' },
          ],
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.rb-dialog_action {
  border-radius: 4px;
  text-shadow: var(--text-shadow_drop);
  min-width: 6rem;
}
</style>
